import { Pipe, PipeTransform } from '@angular/core';

import { RecursoCampanhaSearch } from '../recurso-campanha-search';

@Pipe({
    name: 'recursoCampanhaSelectTipoFilterPipe',
    pure: false
})
export class RecursoCampanhaSelectTipoFilterPipe implements PipeTransform {
    transform(recursos: RecursoCampanhaSearch[] = [], tipoFilter: number): RecursoCampanhaSearch[] {
        // Se não for filtrado por nenhum tipo, então retorna todos os recursos informados
        if (!recursos || recursos.length === 0 || !tipoFilter) {
            return recursos;
        }
        return recursos?.filter(recursoFilter => recursoFilter.tipo === tipoFilter);
    }
}
